<template>
  <div class="client-auth-container">
    <div class="client-auth-box">
      <div class="client-auth-header">
        <el-tooltip
          content="ioooo"
          :effect="$theme.tooltipKey()">
          <p>Client列表</p>
        </el-tooltip>
      </div>
      <div class="common-button-box">
        <el-button
          type="primary"
          class="primary-btn"
          size="small"
          @click="openClientDialog"
          >新增Client</el-button
        >
        <el-button
          size="small"
          class="normal-btn"
          @click="openDeleteDialog"
          >删除Client</el-button
        >
      </div>
      <div class="common-table-box">
        <el-table
          :data="clientList"
          highlight-selection-row
          class="publish-table"
          @select="selectChange"
          @select-all="selectChange"
          height="100%"
          ref="clientTable">
          <el-table-column
            type="selection"
            width="60">
          </el-table-column>
          <el-table-column
            label="clientId"
            prop="clientId"></el-table-column>
          <el-table-column
            label="密钥"
            prop="secretKey"></el-table-column>
          <el-table-column
            label="范围"
            prop="scopes">
            <template v-slot="{ row }">
              {{ formatScopes(row.scopes) }}
            </template>
          </el-table-column>
          <el-table-column
            label="描述"
            prop="description"></el-table-column>
          <el-table-column
            label="操作"
           
            width="240">
            <template v-slot="{ row }">
              <div class="justify-flex operation-cell">
                <el-button
                  class="copy"
                  type="text"
                  data-clipboard-action="copy"
                  :data-clipboard-text="`ClientId：${row.clientId}\nSecretKey：${row.secretKey}`"
                  @click="copyContent"
                  >复制</el-button
                >
                <el-button
                  @click="editClient(row)"
                  type="text"
                  size="small"
                  >编辑Client</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="e => openDeleteDialog(e, row)"
                  >删除Client</el-button
                >
              </div>
            </template>
          </el-table-column>
          <template slot="empty">
            <div class="empty-box">
              <bj-empty
                :image="require('@/assets/img/no-data.png')"
                class="empty-page">
                <template slot="description">没有找到Client</template>
                <el-button
                  type="primary"
                  size="small"
                  @click="openClientDialog"
                  >新增Client</el-button
                >
              </bj-empty>
            </div>
          </template>
        </el-table>
      </div>
    </div>
    <client-dialog
      :visible="clientDialogVisible"
      :clientInfo="clientInfo"
      :closeDialog="closeClientDialog"
      :queryClientList="queryClientList" />

    <el-dialog
      title="删除用户"
      width="30%"
      :before-close="cancelDelete"
      :visible.sync="deleteDialogvisible"
      class="custom-dialog">
      <div class="message-box">
        <span><i class="el-icon-warning icon"></i></span>
        <span>确定删除所选Client吗？</span>
      </div>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button
          size="small"
          class="hollowOut-btn primary-ang-btn"
          @click="cancelDelete"
          >取 消</el-button
        >
        <el-button
          type="primary"
          class="primary-btn primary-ang-btn"
          size="small"
          @click="submitDelete"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Clipboard from 'clipboard'
import clientDialog from '@/components/ClientDialog.vue'

import { getClientList, deleteClient } from '@/service/interface'

export default {
  data() {
    return {
      clientList: [],
      selectClients: [],
      clientInfo: null,

      clientDialogVisible: false,

      deleteDialogvisible: false
    }
  },
  components: { clientDialog },
  mounted() {
    this.queryClientList().then(() => {
      this.$nextTick(() => {
        let copybtn = document.getElementsByClassName('copy')
        this.clipboard = new Clipboard(copybtn)
      })
    })
  },
  methods: {
    queryClientList() {
      return new Promise(resolve => {
        let params = {
          maxResultCount: 1000,
          skipCount: 0,
          sorting: ''
        }
        getClientList(params).then(res => {
          if (res.status === 200) {
            this.clientList = res.data.data.items
            resolve()
          }
        })
      })
    },
    searchClient() {
      let params = {
        maxResultCount: 1000,
        skipCount: 0,
        sorting: ''
      }
      getClientList(params).then(res => {
        if (res.status === 200) {
          this.clientList = res.data.data.items
        }
      })
    },
    copyContent() {
      this.clipboard.on('success', () => {
        this.$message.success('复制成功！')
      })

      this.clipboard.on('error', () => {
        this.$message.error('复制失败，请手动复制！')
      })
    },
    openClientDialog() {
      this.clientDialogVisible = true
    },
    openDeleteDialog(e, clientInfo) {
      if (clientInfo) {
        this.clientInfo = clientInfo
        this.deleteDialogvisible = true
        return
      }
      if (this.selectClients.length) {
        this.deleteDialogvisible = true
      } else {
        this.$message.error('请选择用户！！！')
      }
    },
    selectChange(selection) {
      this.selectClients = selection
    },
    setAllExpand(state) {
      let nodes = this.$refs.tree.store._getAllNodes()
      for (let i in nodes) {
        nodes[i].expanded = state
      }
    },
    editClient(clientInfo) {
      this.clientInfo = clientInfo
      this.clientDialogVisible = true
    },
    closeClientDialog() {
      this.clientInfo = null
      this.clientDialogVisible = false
    },
    submitDelete() {
      if (this.clientInfo) {
        deleteClient(this.clientInfo.id).then(response => {
          if (response.status === 200) {
            this.queryClientList().then(() => {
              this.$message.success('删除成功！！！')

              this.deleteDialogvisible = false
              this.clientInfo = null
            })
          }
        })
      } else {
        let promiseArray = []
        this.selectClients.forEach(item => {
          let promise = deleteClient(item.id)
          promiseArray.push(promise)
        })
        Promise.all(promiseArray).then(res => {
          if (res.length === promiseArray.length) {
            this.queryClientList().then(() => {
              this.$message.success('删除成功!')

              this.deleteDialogvisible = false
            })
          }
        })
      }
    },
    cancelDelete() {
      this.deleteDialogvisible = false
      this.clientInfo = null
    },
    formatScopes(scopes) {
      let scopesList = [
        { label: '基础数据', value: 'Base' },
        { label: '项目管理', value: 'Project' },
        { label: '资源发布', value: 'Resource' }
      ]

      let scopesStr = '--'
      scopes = JSON.parse(scopes)

      let formatScopes = []
      scopes.forEach(item => {
        let find = scopesList.find(el => el.value === item)
        if (find) {
          formatScopes.push(find.label)
        }
      })
      if (formatScopes.length) {
        scopesStr = formatScopes.join('、')
      }

      return scopesStr
    }
  }
}
</script>

<style scoped lang="less">
@import '@/assets/css/publishSearch.less';
.client-auth-container {
  display: flex;
  justify-content: space-between;
  height: 100%;
  overflow-y: hidden;

  .custom-dialog {
    :deep(.el-dialog) {
      border-radius: 16px;
      overflow: hidden;
      border: none;
      background: var(--dialog-bgColor);
      box-shadow: var(--base-bg-dark-color30);
      margin-top: 20vh !important;

      .el-dialog__header {
        height: 40px !important;
        background-color: var(--dialog-header-bgColor) !important;
        font-size: 16px;
        font-weight: 400;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 16px !important;
        border-bottom: 1px solid var(--dialog-header-border-color) !important;

        .el-dialog__title {
          color: var(--dialog-header-text-color);
        }

        .el-dialog__headerbtn {
          color: var(--dialog-header-icon-color);
          width: 24px;
          height: 24px;
          position: inherit;
          &:hover {
            width: 24px;
            height: 24px;
            background: var(--dialog-header-icon-bgColor);
            border-radius: 4px;

            .el-icon {
              color: var(--dialog-header-icon-hover-color);
            }
          }
        }
      }

      .el-dialog__body {
        color: var(--dialog-content-label-color);
      }
      .el-dialog__footer {
        padding: 16px 0;
        padding-right: 16px;
        border-top: 1px solid var(--dialog-footer-border-color);

        .dialog-footer {
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
    }
  }

  .message-box {
    display: flex;
    margin-bottom: 10px;

    .icon {
      color: var(--base-light-color10);
      margin-right: 5px;
    }
  }

  .dom-box {
    margin-left: 20px;

    .el-checkbox {
      color: var(--default-color);
    }
  }
  .client-auth-box {
    width: 100%;
    padding: 15px;
    border-radius: 5px;
    background: var(--page-bgColor);
    box-shadow: var(--base-bg-dark-color30);
    .client-auth-header {
      display: flex;
      justify-content: space-between;

      p {
        height: 20px;
        line-height: 10px;
        padding: 4px 10px;
        border-left: 4px solid var(--base-primary-color);
        color: var(--page-title-color);
      }

      .search-input {
        width: 300px;

        .prepend-select {
          width: 90px;
        }
      }
    }

    .common-button-box {
      display: flex;
      text-align: left;
      padding: 16px 0;
    }

    .common-table-box {
      height: calc(100% - 84px);
      overflow-y: auto;

      .copy-content {
        user-select: text;
      }
    }
  }
}
</style>
